var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.41 8.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ff0008;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_20211011_Desktop",
    "data-name": "20211011_Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2.0-Coverage-_-1.0-Pass-_-1.4-Quote",
    "data-name": "2.0-Coverage-/-1.0-Pass-/-1.4-Quote"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Know-More"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-_-Chevrons-_-Right---Blue",
    "data-name": "Icons-/-Chevrons-/-Right---Blue"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-2",
    className: "cls-1",
    points: "0.69 7.32 6.81 1.41 12.69 7.45"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpRed);
export default __webpack_public_path__ + "static/media/chevron-up-red.3c8e8090a2aafd3e2c4d2a01dd9426ae.svg";
export { ForwardRef as ReactComponent };